import * as collection from 'BASE/common/collection/collection';
import Constant from 'BASE/common/lotteryConstant';
import functionConfig from 'YD/functionConfig';
import SecurityCenterBase from '#BASE/components/accountInfo/SecurityCenter';
import { storage } from 'BASE/common/util/util.storage';

export default {
    mixins: [functionConfig, SecurityCenterBase],
    data() {
        return {
            collectedFunction: [],
        };
    },
    computed: {
        haveMyDailyPayAndContract() {
            return this.$store.state.userinfo.privileges.haveMyDailyPayAndContract;
        },
        haveDailyPay() {
            return this.$store.state.userinfo.privileges.haveDailyPay;
        },
        haveCGDailyPay() {
            return this.$store.state.userinfo.privileges.haveCGDailyPay;
        },
        haveDailyPayExternalGame() {
            return this.$store.state.userinfo.privileges.haveDailyPayExternalGame;
        },
        bonusManagementAllowed() {
            return this.$store.state.userinfo.privileges.bonusManagementAllowed;
        },
        proportionalDividendAllowed(){
            return this.$store.state.userinfo.privileges.haveProportionalDividend;
        },
        externalGameProportionalDividendAllowed(){
            return this.$store.state.userinfo.privileges.haveExternalGameProportionalDividend;
        },
        dailyPayCreationAllowed() {
            return this.$store.state.userinfo.privileges.dailyPayCreationAllowed;
        },
        dailyPayCGCreationAllowed(){
            return this.$store.state.userinfo.privileges.dailyPayCGCreationAllowed;
        },
        externalGameDailyPayCreationAllowed() {
            return this.$store.state.userinfo.privileges.externalGameDailyPayCreationAllowed;
        },
        contractCreationAllowed() {
            return this.$store.state.userinfo.privileges.contractCreationAllowed;
        },
        contractPermission() {
            return this.$store.state.userinfo.privileges.contractPermission;
        },
        isTransferPointEnabled(){
            return this.$store.state.userinfo.privileges.isTransferPointEnabled;
        },
        AllFunctions() {
            let arr = [];
            this.MyAccount.forEach(i => {
                if (i.href === 'Center/MyDailyPayAndContract' && !this.haveMyDailyPayAndContract) {
                    return true;
                } else {
                    arr.push(i)
                }
            });
            this.ReportCenter.forEach(i => {
                if (i.href === 'Center/DividendRecord' && this.contractPermission.length === 0) {
                    return true;
                } else {
                    arr.push(i)
                }
            });
            this.CashCenter.forEach(i => {
                if (i.href.indexOf('Center/Transfer') >= 0) {
                    if(this.isTransferPointEnabled){
                        arr.push(i)
                    }
                } else {
                    arr.push(i)
                }
            });
            this.TeamCenter.forEach(i => {
                if (i.href === 'Center/BonusManagement' && !this.bonusManagementAllowed) {
                    return true;
                } else if (i.href === 'Center/ProportionalDividend' && !this.proportionalDividendAllowed) {
                    return true;
                } else if (i.href === 'Center/ExternalGameProportionalDividend' && !this.externalGameProportionalDividendAllowed) {
                    return true;
                } else {
                    arr.push(i)
                }
            });
            return arr;
        },
        CollectedFunctions() {
            let result = [];
            for (let link of this.collectedFunction) {
                let func = this.AllFunctions.find(f => f.href == link);
                if (func) {
                    result.push(func);
                }
            }

            return result;
        },
    },
    methods:{
        async SetDefaultCollection(collectionAry){
            let key = storage.keys.COLLECTION_INIT + this.$store.state.userinfo.userName;
            let hasInit = storage.local.get(key);
            if(!hasInit && collectionAry.length === 0){
                await collection.setCollection(this.$store.state.userinfo.userName, ["Center/ProfitReport?PageType=Self","Center/BetRecord?PageType=Self","Center/CashFlowRecord?PageType=Self"], Constant.CollectionType.FUNCTION);
            }
            storage.local.set(key, true);
        },
        async UpdateCollection(){
            try {
                await this.SetDefaultCollection(this.collectedFunction);
                this.collectedFunction = await collection.getCollection(this.$store.state.userinfo.userName, Constant.CollectionType.FUNCTION);
            } catch (err) {
                this.$dialog.warning('加载失败');
            }
        },
        switchCollectionEdit(enable){
            if(this.$parent && this.$parent.switchCollectionEdit)
            {
                this.$parent.switchCollectionEdit(enable);
            }
        },
    },
    async mounted() {
        await this.UpdateCollection();
    },
};